import React from 'react'

import { isDesktop } from 'utils/device'

import Splotch from './Splotch'
import { Container } from './styles'

import { ANIMATION_TRIGGER_DELAY } from '../constants'
import useCreateSplotch from '../hooks/useCreateSplotch/useCreateSplotch'
import useTriggerAnimation from '../hooks/useTriggerAnimation'

const FoodSplotch = props => {
    const { uuid, teacher } = props
    const animate = useTriggerAnimation(ANIMATION_TRIGGER_DELAY)
    const splotchStyles = useCreateSplotch(uuid, teacher)

    const splotches = splotchStyles.map((styles, i) => (
        <Splotch key={`tile-uuid-${i}`} {...styles} teacher={teacher} />
    ))

    if (!isDesktop) return null

    return (
        <Container className="splotch" animate={animate} {...props}>
            {splotches}
        </Container>
    )
}

export default FoodSplotch
